/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerUpdateChangeOrderAccessMutationRequest, UserControllerUpdateChangeOrderAccessMutationResponse, UserControllerUpdateChangeOrderAccessPathParams, UserControllerUpdateChangeOrderAccess400, UserControllerUpdateChangeOrderAccess401, UserControllerUpdateChangeOrderAccess403, UserControllerUpdateChangeOrderAccess404 } from "../../models/usersController/UserControllerUpdateChangeOrderAccess";

function getUserControllerUpdateChangeOrderAccessUrl(userId: UserControllerUpdateChangeOrderAccessPathParams["userId"]) {
  const res = { method: 'PATCH', url: `/api/v1/users/${userId}/change-order-access` as const }  
  return res
}

/**
 * @summary Grant or revoke Change Order access for a user
 * {@link /api/v1/users/:userId/change-order-access}
 */
export async function userControllerUpdateChangeOrderAccess(userId: UserControllerUpdateChangeOrderAccessPathParams["userId"], data?: UserControllerUpdateChangeOrderAccessMutationRequest, config: Partial<RequestConfig<UserControllerUpdateChangeOrderAccessMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<UserControllerUpdateChangeOrderAccessMutationResponse, ResponseErrorConfig<UserControllerUpdateChangeOrderAccess400 | UserControllerUpdateChangeOrderAccess401 | UserControllerUpdateChangeOrderAccess403 | UserControllerUpdateChangeOrderAccess404>, UserControllerUpdateChangeOrderAccessMutationRequest>({ method : "PATCH", url : getUserControllerUpdateChangeOrderAccessUrl(userId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}